"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _reactTransitionGroup = require("react-transition-group");

var _dismissIcon = _interopRequireDefault(require("../Icon/dismissIcon"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _key = require("../../constants/key.codes");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var EXITING_STATUS = 'exiting';
var ENTERED_STATUS = 'entered';

function Modal(_ref) {
  var children = _ref.children,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible,
      small = _ref.small,
      large = _ref.large,
      _ref$dismissible = _ref.dismissible,
      dismissible = _ref$dismissible === void 0 ? true : _ref$dismissible,
      onDismiss = _ref.onDismiss,
      props = _objectWithoutProperties(_ref, ["children", "visible", "small", "large", "dismissible", "onDismiss"]);

  return _react.default.createElement(_reactTransitionGroup.Transition, {
    in: visible,
    timeout: 500
  }, function (status) {
    return _react.default.createElement(ModalWithTransition, _extends({
      transitionStatus: status,
      visible: visible,
      small: small,
      large: large,
      dismissible: dismissible,
      onDismiss: onDismiss
    }, props), children);
  });
}

function ModalWithTransition(_ref2) {
  var children = _ref2.children,
      transitionStatus = _ref2.transitionStatus,
      visible = _ref2.visible,
      small = _ref2.small,
      large = _ref2.large,
      dismissible = _ref2.dismissible,
      onDismiss = _ref2.onDismiss,
      props = _objectWithoutProperties(_ref2, ["children", "transitionStatus", "visible", "small", "large", "dismissible", "onDismiss"]);

  var isExiting = transitionStatus === EXITING_STATUS;
  var hasEntered = transitionStatus === ENTERED_STATUS;
  var active = visible || hasEntered || isExiting;

  if (!active) {
    return null;
  }

  var onKeyDown = function onKeyDown(event) {
    if (event.key === _key.ESC_KEY && dismissible) {
      onDismiss();
    }
  };

  var modalStyles = ['co-modal', {
    'co--active': active,
    'co--fade-out': isExiting,
    'co-modal--large': large,
    'co-modal--small': small
  }];
  return _react.default.createElement(_styler.default, {
    classNames: modalStyles
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles,
      onKeyDown: onKeyDown,
      tabIndex: "0"
    }, (0, _getNativeProps.default)(props)), _react.default.createElement("div", {
      className: "co-modal__overlay"
    }), _react.default.createElement(ModalWindow, {
      dismissible: dismissible,
      onDismiss: onDismiss
    }, children));
  });
}

var ModalWindow = function ModalWindow(_ref3) {
  var children = _ref3.children,
      dismissible = _ref3.dismissible,
      onDismiss = _ref3.onDismiss;
  return _react.default.createElement("div", {
    className: "co-modal__dialog",
    tabIndex: "-1"
  }, children, dismissible ? _react.default.createElement(_dismissIcon.default, {
    ariaLabel: "Close",
    small: true,
    onClick: onDismiss
  }) : null);
};

var exclusiveSizes = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
Modal.propTypes = {
  children: _propTypes.node.isRequired,
  visible: _propTypes.bool,
  small: exclusiveSizes,
  large: exclusiveSizes,
  dismissible: _propTypes.bool,
  onDismiss: (0, _airbnbPropTypes.requiredBy)('dismissible', _propTypes.func)
};
var _default = Modal;
exports.default = _default;
Modal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Modal",
  "props": {
    "visible": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "dismissible": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": ""
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": ""
    },
    "onDismiss": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('dismissible', func)"
      },
      "required": false,
      "description": ""
    }
  }
};